// English
const lang = {
    contact: 'Contact',
    born: 'Born',
    bornIn: 'in',
    experience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    projects: 'Projects',
    contributions: 'Contributions',
    about: 'About me',
    today: 'Today',
    loading: 'Loading...',
    error: 'An unexpected error happened'
};
export default lang;
